import { TrustpilotSection } from 'components/home-page/trustpilot-section/TrustpilotSection';
import AsSeenOn from 'components/home-page-2026/as-seen-on';
import Hero from 'components/home-page-2026/hero';
import HowItWorks from 'components/home-page-2026/how-it-works';
import Prizes from 'components/home-page-2026/prizes';
import QuickAnswers from 'components/home-page-2026/quick-answers';
import Trees from 'components/home-page-2026/trees';
import Winners from 'components/home-page-2026/winners';
import MainLayout from 'components/layout/MainLayout';
import { getHomePage2026Value } from 'utils/ab-test/abTests';
import { WinnerHomepage } from 'utils/plasmicCMS';

export interface HomePageV1Props {
  nextDrawDate: string;
  withCountdown?: boolean;
  prizes: HomePagePrize[];
  winners: WinnerHomepage[];
  variant: ReturnType<typeof getHomePage2026Value>;
}

export interface HomePagePrize {
  title: string;
  imageSrc: string;
  imageAlt: string;
  mainCategory: string;
  href: string;
}

const HomePageV1 = ({
  withCountdown,
  nextDrawDate,
  prizes,
  winners,
  variant,
}: HomePageV1Props) => {
  return (
    <MainLayout
      limitItemWidths
      clearHeader
      displayHeaderOnScroll
      footerBackground="absoluteWhite"
    >
      <div className="daymadeTypographyReset">
        <Hero withCountdown={withCountdown} nextDrawDate={nextDrawDate} />
        <AsSeenOn />
        <Prizes prizes={prizes} />
        {variant === 'V5.1' ? (
          <Winners winners={winners} background="white" />
        ) : (
          <HowItWorks background="white" />
        )}
        {variant === 'V5.1' ? (
          <HowItWorks background="darkBlue" />
        ) : (
          <Winners winners={winners} background="darkBlue" />
        )}

        <TrustpilotSection hideTitle />
        <Trees />
        <QuickAnswers />
      </div>
    </MainLayout>
  );
};

export default HomePageV1;
